'use client'

import type {
  UseImagePlaceholderProps,
  UseImagePlaceholderReturnType,
} from '@maestro/commerce-blocks/components/image-product/image-product.types'

import { useMemo } from 'react'

// Module-level cache to persist cachedUrls across component remounts
// Key: base image URL, Value: cached PLP image URL
const cachedUrlMap = new Map<string, string>()

export function useImagePlaceholder(
  props: UseImagePlaceholderProps
): UseImagePlaceholderReturnType {
  const { src, blurDataUrl, cachedUrl, cacheKey } = props

  const placeholderSrc = useMemo(() => {
    const key = cacheKey || src

    // Store cachedUrl in module-level cache if provided
    if (cachedUrl) {
      cachedUrlMap.set(key, cachedUrl)
    }

    // Look up from cache - persists across component remounts
    const preservedCachedUrl = cachedUrlMap.get(key)

    // Priority: preserved cachedUrl > current cachedUrl > blurDataUrl > src (thumbnail)
    return preservedCachedUrl || cachedUrl || blurDataUrl || src
  }, [blurDataUrl, cacheKey, cachedUrl, src])

  return {
    placeholderSrc,
  }
}
